import React from "react";
import { AppValue, AppDisbatch } from "../../../../contexts/app";
import { useParams, useHistory } from "react-router-dom";
import AddComponent from "./addcomponent";
import CompCard from "./compcard";
import styles from "./styles.module.css";

export default function Components({ setTitle, setOpen }) {
  const { appId, pageId } = useParams();
  const { components } = React.useContext(AppValue);
  const history = useHistory();

  React.useEffect(() => {
    const selected = components.find((p) => p.id === pageId);
    if (selected) {
      setTitle(selected.name);
    }
  }, [components, pageId]);

  const handleNavigate = (comp) => {
    history.push(`/${appId}/canvas/components/${comp.id}`);
    setOpen(false);
  };

  return (
    <div className={styles.pages}>
      <AddComponent setOpen={setOpen} appId={appId} />
      {components.map((c) => {
        return <CompCard onSelect={handleNavigate} key={c.id} component={c} />;
      })}
    </div>
  );
}
